import { render, staticRenderFns } from "./AppLegend.vue?vue&type=template&id=328f66a0&"
import script from "./AppLegend.vue?vue&type=script&lang=js&"
export * from "./AppLegend.vue?vue&type=script&lang=js&"
import style0 from "./AppLegend.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports